import type { KeyboardEvent } from 'react';
import { useSearchParams } from 'react-router-dom';
import OffersTab from '../components/offers/OffersTab';
import PackagesTab from '../components/packages/PackagesTab';
import { usePackagesT } from '../components/packages/packagesI18n';

type PromotionsTab = 'offers' | 'packages';
const TABS: PromotionsTab[] = ['offers', 'packages'];

/**
 * Promotions: Offers (Spec 062) and Packages (Spec 081b) tabs. The tab lives in the URL
 * (`?tab=packages`; offers is the default) so links and Back work.
 */
export default function PromotionsPage() {
  const { t } = usePackagesT();
  const [searchParams, setSearchParams] = useSearchParams();
  const tab: PromotionsTab = searchParams.get('tab') === 'packages' ? 'packages' : 'offers';

  const selectTab = (next: PromotionsTab) => {
    if (next !== tab) setSearchParams(next === 'packages' ? { tab: 'packages' } : {});
  };
  const onKeyDown = (e: KeyboardEvent<HTMLButtonElement>) => {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    e.preventDefault();
    const next = TABS[(TABS.indexOf(tab) + 1) % TABS.length];
    selectTab(next);
    document.getElementById(`promo-tab-${next}`)?.focus();
  };

  return (
    <div className="partner-services-page offer-page">
      <div className="pkg-tabs" role="tablist" aria-label={t('packages.tab.label')}>
        {TABS.map((key) => (
          <button
            key={key}
            id={`promo-tab-${key}`}
            type="button"
            role="tab"
            aria-selected={tab === key}
            aria-controls="promo-tabpanel"
            tabIndex={tab === key ? 0 : -1}
            className={`pkg-tab${tab === key ? ' pkg-tab--active' : ''}`}
            onClick={() => selectTab(key)}
            onKeyDown={onKeyDown}
          >
            {t(`packages.tab.${key}`)}
          </button>
        ))}
      </div>
      <div id="promo-tabpanel" role="tabpanel" aria-labelledby={`promo-tab-${tab}`}>
        {tab === 'packages' ? <PackagesTab /> : <OffersTab />}
      </div>
    </div>
  );
}
